<template>
  <modal name="patientDetailModal" class="custom-modal" :width='"605px"' :height="'auto'"
         :scrollable="true" @before-open="beforeOpen" @before-close="beforeClose" :clickToClose="false">
    <div class="modal-padding">
      <div class="modal-close-img" @click="hideModal()">
        <div class="icon-close"></div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="title">details</div>
        </div>
        <div class="col-md-12">
          <div class="text">Name: {{patientDetail.firstName}} {{patientDetail.lastName}}</div>
          <div class="text">Email address: {{patientDetail.email}}</div>
          <div class="text">Employer ID: {{patientDetail.employerId}}</div>
          <div class="text">Signed up: {{patientDetail.signedUpAt}}</div>
          <div class="text">Email reminders sent:</div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
  import 'vue-awesome/icons/search';
  import Icon from 'vue-awesome/components/Icon';
  import Multiselect from 'vue-multiselect';

  import {mapGetters, mapActions, mapMutations} from 'vuex';

  // import constant from '../../_consts';

  export default {
    name: 'patientDetailModal',
    components: {
      Icon,
      Multiselect
    },
    props: {
    },
    data () {
      return {
        patientDetail: {
          type: Object,
          default: {}
        }
      }
    },
    methods: {
      hideModal () {
        this.$modal.hide('patientDetailModal');
      },
      beforeOpen (patientDetail) {
        this.patientDetail = patientDetail.params;
      },
      beforeClose () {
      },
      ...mapActions({
        // getEventById: 'ACTION_GET_EVENT_BY_ID'
      }),
      ...mapMutations({
        //  setIsLoading: 'MUTATION_SET_IS_LOADING'
      })
    },
    computed: {
      ...mapGetters({
        getIsLoadingModal: 'GETTER_IS_LOADING_MODAL'
      })
    }
  }
</script>

<style lang="less" scoped>
  @import '../../../styles/variables.less';

  .custom-modal {
    .modal-padding {
      padding: 26px 24px 30px 24px;
      .modal-close-img {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        .icon-close {
          margin: 1.5px 1.5px;
          width: 27px;
          height: 27px;
          color: @grey-3;
          background-color: @grey-3;
          -webkit-mask: url('../../../../static/img/action-close.svg') no-repeat center;
          mask: url('../../../../static/img/action-close.svg') no-repeat center;
          background: url('../../../../static/img/action-close-grey.svg');
        }
      }
      .title {
        color: @black-3;
        font-family: @font-family-main;
        font-size: 32px;
        font-weight: 800;
        letter-spacing: -1px;
        line-height: 40px;
        text-transform: uppercase;
        margin-bottom: 20px;
      }
      .text {
        color: @grey-8;
        font-family: @font-family-main;
        font-size: 16px;
        line-height: 24px;
        height: 45px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PatientDetailModal.vue?9abe6494